import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import TreeView from "app/components/treeView/trend";
import { getLoggedInUser, getProductVariant } from "utilities";
import { actionSuccess, hideLoader, actionError } from "middleware/actions/utilityAction";
import { showAlertBox } from "middleware/actions/alertBoxAction";
import {
  fetchProductTrend,
  saveProductTrend,
  deleteManyProductTrend,
  updateContentTags,
  fetchSingleProduct,
  saveProductTrendSequence,
  updateTrends,
} from "middleware/services/productApi";
import { processingSubmitProduct } from "middleware/services/cmsApi";
import "app/components/popup/index.scss";
import { COMMON_ACCESS_ACTION, PRODUCT_VARIANT, SUCCESS_TREND } from "constants";
import PropTypes from "prop-types";

const TaxomonyUI = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const productVariant = getProductVariant();

  const productId = props.productId;
  const [clickSaveSubmit, setClickSaveSubmit] = useState(false);
  const [updateClick, setUpdateClick] = useState(false);
  const [saveTreeData, setSaveTreeData] = useState(false);
  const [saveTreeDataAction, setSaveTreeDataAction] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(false);
  const [backLink, setBackLink] = useState(
    props.editData
      ? props.companyId
        ? {
            path: `/company/${props.companyId}/edit#product`,
            data: { companyId: props.companyId },
          }
        : { path: `/product`, data: { companyId: undefined } }
      : undefined
  );

  /* Common access */
  const accessActionAdd = props?.interfaceActionAccess?.includes(COMMON_ACCESS_ACTION.ADD);
  const accessActionAddTags = props?.interfaceActionAccess?.includes(COMMON_ACCESS_ACTION.ADD_TAGS);
  const accessActionDelete = props?.interfaceActionAccess?.includes(COMMON_ACCESS_ACTION.DELETE);
  const accessActionSubmit = props?.interfaceActionAccess?.includes(COMMON_ACCESS_ACTION.SUBMIT);
  const accessActionTaxonomyShowInProduct = props?.interfaceActionAccess?.includes(COMMON_ACCESS_ACTION.SHOW_IN_PRODUCT);

  const handleSubmit = (selectedTech, checkValues, callback, sgfData = undefined, selectedTrend) => {
    if (
      props.path === "/processing/company/:companyId/product/:productId/edit" ||
      props.path == "/company/:companyId/product/:productId/edit" ||
      props.path == "/product/:productId/edit" ||
      props.path == "/data-qc/company/:companyId/product/:productId/edit"
    ) {
      saveTrend(selectedTech, checkValues, callback, sgfData, selectedTrend);
    }
  };

  const saveTrend = (selectedTech, taxonomyIds, callback, sgfData, selectedTrend) => {
    if (selectedTech.length > 0) {
      deleteManyProductTrend(productId, selectedTech, true)
        .then(() => {
          if (taxonomyIds.length > 0) {
            try {
              const response = saveProductTrend(productId, taxonomyIds, sgfData, true);
              response
                .then(() => {
                  if (submitStatus) {
                    setTimeout(() => {
                      saveTaxonomyProcessing(selectedTrend, taxonomyIds, callback);
                    }, [2000]);
                  }
                  callback();
                })
                .catch((e) => {
                  dispatch(actionError("Something Went Wrong...!"));
                  setSubmitStatus(false);
                });
            } catch (e) {
              dispatch(hideLoader());
              dispatch(actionError("Something Went Wrong...!"));
              setSubmitStatus(false);
            }
          } else {
            dispatch(actionError("Please select taxonomy."));
            setSaveTreeData(false);
            setSaveTreeDataAction(false);
            setClickSaveSubmit(false);
            setSubmitStatus(false);
          }
        })
        .catch((e) => {
          dispatch(hideLoader());
          dispatch(actionError("Something Went Wrong...!"));
          setSubmitStatus(false);
        });
    }
    setSaveTreeData(false);
    setSaveTreeDataAction(false);
    setSubmitStatus(false);
  };

  const saveTaxonomyProcessing = (selectedTech, taxonomyIds, callback) => {
    const loggedInUser = getLoggedInUser();
    const payload = {
      userId: loggedInUser._id,
      trendId: selectedTech,
    };

    dispatch(
      showAlertBox({
        okCallback: async () => {
          processingSubmitProduct(productId, "trend", payload)
            .then((response) => {
              if (response.status === 200) {
                setClickSaveSubmit(false);
                setUpdateClick(false);
                dispatch(actionSuccess(`Product trend successfully submitted.`));

                setSaveTreeData(false);
                return { status: "success" };
              }
            })
            .catch((err) => {
              dispatch(actionError(err.data.message || "Something went wrong."));
              setSaveTreeData(false);
            });
        },
        okText: "Submit",
        cancelText: "Cancel",
        content: "Are you sure you want to submit ?",
        title: "dialogAlertCss",
      })
    );
  };

  const deleteTrend = (checkedTrends, callback, callback2, selectedTech) => {
    // let selectedTechnology = selectedTech
    deleteManyProductTrend(productId, checkedTrends, true)
      .then((res) => {
        callback();
      })
      .catch((err) => {
        dispatch(actionError("Something went wrong."));
      });
  };

  const handleSaveTagSequence = (sortedTrends, callback) => {
    saveProductTrendSequence(productId, sortedTrends)
      .then((res) => {
        callback();
        dispatch(actionSuccess("Taxonomy sequence added Successfully."));
      })
      .catch((err) => {
        dispatch(actionError("Something Went Wrong...!"));
      });
  };

  const udpateTempTrends = async () => {
    await updateTrends(productId)
      .then((res) => {
        if (res) {
          dispatch(actionSuccess(SUCCESS_TREND));
        } else {
          dispatch(actionError("Something went wrong."));
        }
      })
      .catch((err) => {
        dispatch(actionError(err?.data?.message || "Something went wrong."));
      });
  };

  return (
    <div className="taxonomy-form-container">
      <TreeView
        handleSave={saveTrend}
        saveTreeData={saveTreeData}
        contentId={productId}
        fetchContentTagging={fetchProductTrend}
        loadOtherTagInfo={props.loadOtherTagInfo}
        isDelete={true}
        setSaveTreeData={setSaveTreeData}
        deleteTrend={deleteTrend}
        accessPermissionTaxonomyDelete={accessActionDelete}
        accessPermissionTaxonomy={accessActionAdd}
        accessPermissionAddTags={accessActionAddTags}
        accessActionTaxonomyShowInProduct={accessActionTaxonomyShowInProduct}
        handleSubmit={handleSubmit}
        submitStatus={submitStatus}
        fetchTags={fetchSingleProduct}
        saveTags={updateContentTags}
        contentModule={"Product"}
        handleSaveTagSequence={handleSaveTagSequence}
        saveTrendTreeData={props.saveTrendTreeData}
        setSaveTrendTreeData={props.setSaveTrendTreeData}
      />
      <div className="taxonomy-form-submit-box">
        <div className="footer-layout">
          {props.selectedIndex > 0 || props.selectedIndex === undefined ? (
            <button
              type="button"
              className="btn btn-outline-dark company-button"
              onClick={() => {
                (props.selectedIndex === undefined && props.setCurrentTab(3)) ||
                  (props.selectedIndex < 5 && props.setCurrentTab(props.selectedIndex - 1));
              }}
            >
              Previous
            </button>
          ) : null}
        </div>
        <div className="footer-layout">
          <button
            type="button"
            className="btn btn-outline-dark company-button"
            onClick={(e) => {
              e.preventDefault();
              backLink === undefined ? history.goBack() : history.push(backLink.path, backLink.data);
            }}
          >
            Cancel
          </button>
          {productVariant === PRODUCT_VARIANT.INSIDER ? (
            <button
              type="button"
              className="btn btn-primary company-button"
              onClick={() => {
                udpateTempTrends();
                props.setSaveTrendTreeData(true);
              }}
            >
              Save
            </button>
          ) : null}
          {accessActionSubmit ? (
            <>
              {(props.path === "/processing/company/:companyId/product/:productId/edit" ||
                props.path == "/company/:companyId/product/:productId/edit" ||
                props.path == "/product/:productId/edit" ||
                props.path == "/data-qc/company/:companyId/product/:productId/edit") &&
              productId ? (
                <button
                  type="button"
                  className="btn btn-primary company-button"
                  onClick={() => {
                    setSubmitStatus(true);
                  }}
                >
                  Submit
                </button>
              ) : (
                ""
              )}
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
};
TaxomonyUI.propTypes = {
  interfaceActionAccess: PropTypes.array,
  companyId: PropTypes.string,
  productId: PropTypes.string,
  path: PropTypes.string,
  selectedIndex: PropTypes.number,
  setCurrentTab: PropTypes.func,
  loadOtherTagInfo: PropTypes.func,
  editData: PropTypes.bool,
  setSaveTrendTreeData: PropTypes.func,
  saveTrendTreeData: PropTypes.bool,
};
export default TaxomonyUI;
